import React from "react";
import { Link } from "react-router-dom";
import { Search } from "lucide-react";
import { Button } from "../../ui/Button";
import { cn } from "../../../lib/utils";
import { DocsSearchBar } from "../ui/DocsSearchBar";
import { ContentPage } from "../../../utils/docs/contentLoader";
import { useKeyboardShortcut } from "../../../hooks/docs/useKeyboardShortcuts";

interface DocsTopNavProps {
  pages: ContentPage[];
  className?: string;
}

export function DocsTopNav({ pages, className }: DocsTopNavProps) {
  const [searchOpen, setSearchOpen] = React.useState(false);

  // Cmd+K / Ctrl+K to open search
  useKeyboardShortcut("cmd+k", () => setSearchOpen(true), true);
  useKeyboardShortcut("ctrl+k", () => setSearchOpen(true), true);

  return (
    <>
      <header
        className={cn(
          "sticky top-0 z-30 border-b border-[var(--su-border-primary)] bg-[var(--su-bg-primary)]",
          className,
        )}
      >
        <div className="flex items-center justify-between px-4 h-16">
          <Link
            to="/docs"
            className="text-lg font-bold text-[var(--su-text-primary)] hover:text-[var(--su-purple-accent)] transition-colors"
          >
            SendUpdates.ai Docs
          </Link>

          <div className="flex items-center gap-4">
            <Button
              variant="ghost"
              size="icon"
              onClick={() => setSearchOpen(true)}
              className="text-[var(--su-text-muted)] hover:text-[var(--su-text-primary)]"
            >
              <Search className="w-5 h-5" />
              <span className="sr-only">Search</span>
            </Button>
          </div>
        </div>
      </header>

      <DocsSearchBar
        pages={pages}
        isOpen={searchOpen}
        onOpenChange={setSearchOpen}
      />
    </>
  );
}
